/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Calendar,
  Video,
  Headphones,
  Users,
  BookOpen,
  Heart,
  DollarSign,
  Sparkles,
  MessageCircle,
  Mic,
  ExternalLink,
  Brain,
  Dumbbell,
  Compass,
  Landmark,
  ArrowRight,
  Check,
  Flame,
  CalendarCheck,
  Quote,
} from 'lucide-react';
import PortalSubPage, { ComingSoonCard } from '../PortalSubPage';
import {
  NEXT_MEETING,
  INTEREST_MAILTO,
  INTEREST_EMAIL,
  CIRCLE_FOCUS,
  CIRCLE_GUEST_SPEAKER,
  CIRCLE_TOPICS,
  CIRCLE_PRICE,
  getReflectionForOffset,
} from '../../data/portalData';

export function PortalFinancial() {
  return (
    <PortalSubPage
      eyebrow="Money &middot; Purpose &middot; Legacy"
      title={<>Build a <span className="italic text-[#D4AF37]">pathway to wealth.</span></>}
      intro="DeWayne Ellis's work anchors the financial-wellness pillar. Start with the check-in below to see where you stand."
      icon={DollarSign}
      cta={[
        { label: 'Take the Financial Wellness Check-In', href: '/survey' },
      ]}
    >
      <div className="rounded-2xl bg-[#111111] border border-white/10 p-6">
        <h3 className="font-cormorant text-2xl font-medium text-white mb-3">
          The Five Questions
        </h3>
        <p className="text-zinc-400 font-manrope text-sm mb-4">
          Five honest yes/no questions that reveal where to focus your energy first.
        </p>
        <ul className="space-y-2 text-zinc-300 font-manrope text-sm">
          <li>1. Do I need help with a retirement plan or portfolio review?</li>
          <li>2. Do I need help starting a college savings plan?</li>
          <li>3. Am I overwhelmed by debt?</li>
          <li>4. Do I have adequate life insurance?</li>
          <li>5. Am I investing to keep up with inflation?</li>
        </ul>
      </div>
      <ComingSoonCard note="Playbooks on real estate, insurance, and wealth-building will follow. Curated by DeWayne Ellis and David Harper." />
    </PortalSubPage>
  );
}
